import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  MenuItem
} from '@mui/material';

const EditCarDialog = ({ open, onClose, onEdit, car }) => {
  const [carData, setCarData] = useState({
    unitNumber: '',
    make: 'Daihatsu',
    model: 'Granmax Blindvan',
    year: '2020',
    kirExpDate: '',
    stnkExpDate: '',
    licensePlateExpDate: '',
    regionalPlate: '',
    ownerName: '',
    bodyColor: '',
    myPertaminaCode: ''
  });
  
  
  const bodyColors = ['White', 'Black', 'Orange', 'Blue', 'Other'];

  useEffect(() => {
    if (car) {
      setCarData({
        ...car,
        kirExpDate: car.kirExpDate ? new Date(car.kirExpDate).toISOString().split('T')[0] : '',
        stnkExpDate: car.stnkExpDate ? new Date(car.stnkExpDate).toISOString().split('T')[0] : '',
        licensePlateExpDate: car.licensePlateExpDate ? new Date(car.licensePlateExpDate).toISOString().split('T')[0] : '',
      });
    }
  }, [car]);

  const handleChange = (e) => {
    setCarData({
      ...carData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = () => {
    onEdit(carData);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Edit Car</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <TextField
              name="unitNumber"
              label="Unit Number"
              fullWidth
              value={carData.unitNumber || ''}
              onChange={handleChange}
            />
          </Grid>
		  <Grid item xs={12} md={6}>
            <TextField
              name="make"
              label="Make"
              fullWidth
              value={carData.make || ''}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              name="model"
              label="Model"
              fullWidth
              value={carData.model || ''}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              name="year"
              label="Year"
              type="number"
              fullWidth
              value={carData.year || ''}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              name="kirExpDate"
              label="KIR Expiration Date"
              type="date"
              fullWidth
              required
              value={carData.kirExpDate}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              name="stnkExpDate"
              label="STNK Expiration Date"
              type="date"
              fullWidth
              value={carData.stnkExpDate || ''}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              name="licensePlateExpDate"
              label="License Plate Expiration Date"
              type="date"
              fullWidth
              value={carData.licensePlateExpDate || ''}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              name="regionalPlate"
              label="Regional License Plate"
              fullWidth
              value={carData.regionalPlate || ''}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              name="ownerName"
              label="Owner Name"
              fullWidth
              value={carData.ownerName || ''}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
			select
			name="bodyColor"
			label="Body Color"
			fullWidth
			required
			value={carData.bodyColor}
			onChange={handleChange}
			>
			{bodyColors.map((color) => (
				<MenuItem key={color} value={color}>
				{color}
				</MenuItem>
			))}
        </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              name="myPertaminaCode"
              label="MyPertamina Code (Google Drive Link)"
              fullWidth
              value={carData.myPertaminaCode || ''}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCarDialog;